import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-area" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group tag-movie-num-range" }
const _hoisted_5 = { class: "p1" }

import { computed, reactive } from 'vue';
import {
  TAG_TYPE1_SYSTEM,
  TAG_TYPE1_USER,
} from 'src/consts/tag';
import type { AdminTagIndexItem } from 'src/models/tag';
import type { AdminListTableField, CustomButton } from 'src/models/adminListTable';

type DisplayData = AdminTagIndexItem & {
  tagTypeLabel: string;
};

interface SearchParams {
  tagName: string;
  dtFrom: string | null;
  dtTo: string | null;
  tagMovieNumFrom: string;
  tagMovieNumTo: string;
}

interface TagTableState {
  search: SearchParams;
  // 検索ボタン押下時に確定する検索条件。フィルタはこちらのみを参照する（入力中は自動検索しない）
  applied: SearchParams;
  showDestroyModal: boolean;
  destroyingTag: AdminTagIndexItem | null;
}

const destroyModalTitle = '削除';
const destroyModalMsg = 'を削除してもよろしいですか？';

export default /*@__PURE__*/_defineComponent({
  __name: 'TagTable',
  props: {
    tags: {}
  },
  emits: ["edit", "destroy", "merge", "search"],
  setup(__props: any, { emit: __emit }) {

const initSearchParams = (): SearchParams => ({
  tagName: '',
  dtFrom: null,
  dtTo: null,
  tagMovieNumFrom: '',
  tagMovieNumTo: '',
});

const props = __props;

const emit = __emit;

const state = reactive<TagTableState>({
  search: initSearchParams(),
  applied: initSearchParams(),
  showDestroyModal: false,
  destroyingTag: null,
});

const doSearch = (): void => {
  emit('search');
  state.applied = { ...state.search };
};

const isSystem = (tag: AdminTagIndexItem): boolean => {
  return tag.tagType1 === TAG_TYPE1_SYSTEM;
};

const getTagTypeLabel = (type: string): string => {
  if (type === TAG_TYPE1_SYSTEM) return 'システム';
  if (type === TAG_TYPE1_USER) return 'ユーザー';

  return type;
};

const filteredTags = computed<AdminTagIndexItem[]>(() => {
  const qTagName = state.applied.tagName;
  const qDtFrom = new Date(state.applied.dtFrom ? state.applied.dtFrom : '');
  const qDtTo = new Date(state.applied.dtTo ? state.applied.dtTo : '');
  const qTagMovieNumFrom = parseInt(state.applied.tagMovieNumFrom ? state.applied.tagMovieNumFrom : '');
  const qTagMovieNumTo = parseInt(state.applied.tagMovieNumTo ? state.applied.tagMovieNumTo : '');
  return props.tags.filter(tag => {
    if (qTagName && tag.tagName.indexOf(qTagName) < 0) return false;

    const ts = new Date(tag.createdAtDate);
    if (qDtFrom && ts < qDtFrom) return false;

    if (qDtTo && ts > qDtTo) return false;

    if (!isNaN(qTagMovieNumFrom) && tag.tagMovieNum < qTagMovieNumFrom) return false;

    if (!isNaN(qTagMovieNumTo) && tag.tagMovieNum > qTagMovieNumTo) return false;

    return true;
  });
});

const displayData = computed<DisplayData[]>(() => {
  return filteredTags.value.map(tag => {
    return {
      ...tag,
      tagTypeLabel: getTagTypeLabel(tag.tagType1),
    };
  });
});

const edit = (obj: AdminTagIndexItem) => {
  emit('edit', obj);
};

const tryDestroy = (obj: AdminTagIndexItem) => {
  state.destroyingTag = obj;
  state.showDestroyModal = true;
};

const doDestroy = () => {
  if (!state.destroyingTag) return;

  emit('destroy', state.destroyingTag);
  state.showDestroyModal = false;
};

const fields: AdminListTableField<DisplayData>[] = [
  { name: 'tagName', label: '動画タグ' },
  { name: 'tagTypeLabel', label: '種類' },
  { name: 'createdAtDate', label: '作成日' },
  { name: 'tagMovieNum', label: '登録動画数' },
];
const customButtons: CustomButton<AdminTagIndexItem>[] = [
  {
    label: '名寄せ',
    clickHandler: (obj: AdminTagIndexItem) => {
      emit('merge', obj);
    },
    isVisible: (obj: AdminTagIndexItem) => !isSystem(obj),
    isDisabled: () => false,
  },
];
const canDelete = (obj: AdminTagIndexItem) => !isSystem(obj);
const canEdit = (obj: AdminTagIndexItem) => !isSystem(obj);

return (_ctx: any,_cache: any) => {
  const _component_MyCalendar = _resolveComponent("MyCalendar")!
  const _component_AdminListTable = _resolveComponent("AdminListTable")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        class: "search-form",
        onSubmit: _withModifiers(doSearch, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-control-label keyword" }, "キーワード", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.search.tagName) = $event))
          }, null, 512), [
            [_vModelText, state.search.tagName]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-control-label" }, "期間", -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_MyCalendar, {
              class: "date-from",
              "date-value": state.search.dtFrom,
              onDateInput: _cache[1] || (_cache[1] = ($event: any) => (state.search.dtFrom = $event))
            }, null, 8, ["date-value"]),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ib waveline ta-center ml4 mr4" }, "〜", -1)),
            _createVNode(_component_MyCalendar, {
              class: "date-to",
              "date-value": state.search.dtTo,
              onDateInput: _cache[2] || (_cache[2] = ($event: any) => (state.search.dtTo = $event))
            }, null, 8, ["date-value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-control-label" }, "登録動画数", -1)),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.search.tagMovieNumFrom) = $event)),
              type: "text",
              class: "ib form-control tag-movie-num-from"
            }, null, 512), [
              [_vModelText, state.search.tagMovieNumFrom]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ib waveline ta-center ml4 mr4" }, "〜", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.search.tagMovieNumTo) = $event)),
              type: "text",
              class: "ib form-control tag-movie-num-to"
            }, null, 512), [
              [_vModelText, state.search.tagMovieNumTo]
            ])
          ])
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "form-group search-btn ta-center" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary"
          }, "検索")
        ], -1))
      ], 32)
    ]),
    _createVNode(_component_AdminListTable, {
      "display-data": displayData.value,
      fields: fields,
      "custom-buttons": customButtons,
      "can-delete": canDelete,
      "can-edit": canEdit,
      onStartEdit: edit,
      onStartDestroy: tryDestroy
    }, null, 8, ["display-data"]),
    (state.showDestroyModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: destroyModalTitle,
          "show-bottom-dismiss-button": true,
          onClose: doDestroy,
          onDismiss: _cache[5] || (_cache[5] = ($event: any) => (state.showDestroyModal = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_5, [
                _cache[12] || (_cache[12] = _createTextVNode("動画タグ", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(state.destroyingTag?.tagName), 1)
              ]),
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: destroyModalMsg
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})